"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryTitle = exports.ClipTextMore = exports.ClipTextContent = exports.ClipPlaceholder = exports.ClipTextBox = exports.DesktopGalleryCaptionBox = exports.MobilePortraitGalleryChangeBox = exports.MobilePortraitGalleryBox = exports.MobileImage = exports.Image = exports.PortraitImageWrapper = exports.LandscapeImageWrapper = exports.GallerySliderItem = exports.GallerySliderBox = exports.GalleryBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Elements = require("../../../../Elements");

var _StyledLayout = require("../../../../../StyledLayout");

var _MediaQueries = _interopRequireDefault(require("../../../../../MediaQueries"));

var _StyledTypography = require("../../../../../StyledTypography");

var _constants = require("../../../../constants/constants");

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var themeTopNavHeight = _constants.adamsDimensions.themeTopNavHeight,
    desktopFooterOffset = _constants.adamsDimensions.desktopFooterOffset,
    mobileFooterOffset = _constants.adamsDimensions.mobileFooterOffset,
    typeThemeModalTitleHeight = _constants.adamsDimensions.typeThemeModalTitleHeight;
var GalleryBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__GalleryBox",
  componentId: "sc-1xff69v-0"
})(["position:relative;height:", ""], function (props) {
  var offset = props.isTabletPortrait ? desktopFooterOffset : mobileFooterOffset;
  var extraOffset = props.isTypeTheme ? " - ".concat(typeThemeModalTitleHeight) : '';

  if (props.vh1) {
    return "calc(".concat(props.vh1 * 100, "px - ").concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, ");");
  }

  return "calc(100vh - ".concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, ");");
});
exports.GalleryBox = GalleryBox;
var GallerySliderBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__GallerySliderBox",
  componentId: "sc-1xff69v-1"
})(["position:relative;height:", ";.slick-prev{left:48px;z-index:2;&:before{font-size:unset;}}.slick-next{right:48px;width:auto;&:before{font-size:unset;}}.slick-slider,.slick-list,.slick-track{height:100%;}.slick-slide{> div{height:100%;}}"], function (props) {
  return "calc(100% - ".concat(props.hasDescription ? '124px' : '36px').concat(props.isTypeTheme ? " - ".concat(typeThemeModalTitleHeight) : '', ")");
});
exports.GallerySliderBox = GallerySliderBox;
var GallerySliderItem = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__GallerySliderItem",
  componentId: "sc-1xff69v-2"
})(["height:100%;outline:none;"]);
exports.GallerySliderItem = GallerySliderItem;
var LandscapeImageWrapper = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__LandscapeImageWrapper",
  componentId: "sc-1xff69v-3"
})(["width:calc(100% - 192px);height:100%;margin:0 auto;", ""], function (props) {
  return props.lastItem && (0, _styledComponents.css)(["padding-right:130px;"]);
});
exports.LandscapeImageWrapper = LandscapeImageWrapper;
var PortraitImageWrapper = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__PortraitImageWrapper",
  componentId: "sc-1xff69v-4"
})(["width:", ";height:100%;margin:0 auto;", ""], function (props) {
  return props.width ? "".concat(props.width, "px") : '0';
}, function (props) {
  return props.lastItem && (0, _styledComponents.css)(["padding-right:0px;"]);
});
exports.PortraitImageWrapper = PortraitImageWrapper;

var Image = _styledComponents["default"].img.withConfig({
  displayName: "Elements__Image",
  componentId: "sc-1xff69v-5"
})(["object-fit:cover;max-width:100%;height:100%;margin:0 auto;"]);

exports.Image = Image;

var MobileImage = _styledComponents["default"].img.withConfig({
  displayName: "Elements__MobileImage",
  componentId: "sc-1xff69v-6"
})(["object-fit:cover;max-width:100%;margin:0 auto;"]);

exports.MobileImage = MobileImage;
var MobilePortraitGalleryBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__MobilePortraitGalleryBox",
  componentId: "sc-1xff69v-7"
})(["width:100%;"]);
exports.MobilePortraitGalleryBox = MobilePortraitGalleryBox;
var MobilePortraitGalleryChangeBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__MobilePortraitGalleryChangeBox",
  componentId: "sc-1xff69v-8"
})(["width:100%;margin-top:24px;margin-bottom:48px;svg{path{fill:", ";}}"], function (props) {
  return props.theme.portfolioForeground1;
});
exports.MobilePortraitGalleryChangeBox = MobilePortraitGalleryChangeBox;
var DesktopGalleryCaptionBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__DesktopGalleryCaptionBox",
  componentId: "sc-1xff69v-9"
})(["width:100%;max-width:756px;margin:0 auto;"]);
exports.DesktopGalleryCaptionBox = DesktopGalleryCaptionBox;
var ClipTextBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__ClipTextBox",
  componentId: "sc-1xff69v-10"
})(["overflow:hidden;padding:0 12px;position:relative;margin-left:-100px;max-height:72px;", ""], function (props) {
  return props.showMore && (0, _styledComponents.css)(["overflow:unset;max-height:unset;"]);
});
exports.ClipTextBox = ClipTextBox;

var ClipPlaceholder = _styledComponents["default"].div.withConfig({
  displayName: "Elements__ClipPlaceholder",
  componentId: "sc-1xff69v-11"
})(["float:left;width:100px;height:72px;"]);

exports.ClipPlaceholder = ClipPlaceholder;
var ClipTextContent = (0, _styledComponents["default"])(_Elements.PortfolioParagraph).withConfig({
  displayName: "Elements__ClipTextContent",
  componentId: "sc-1xff69v-12"
})(["float:right;width:calc(100% - 100px);text-align:center;"]);
exports.ClipTextContent = ClipTextContent;
var ClipTextMore = (0, _styledComponents["default"])(_Elements.PortfolioParagraph).withConfig({
  displayName: "Elements__ClipTextMore",
  componentId: "sc-1xff69v-13"
})(["float:right;width:100px;position:relative;left:100%;height:24px;transform:translate(-100%,-100%);cursor:pointer;background:", ""], function (props) {
  return props.theme.portfolioBackground1;
});
exports.ClipTextMore = ClipTextMore;
var GalleryTitle = (0, _styledComponents["default"])(_StyledTypography.Paragraph).withConfig({
  displayName: "Elements__GalleryTitle",
  componentId: "sc-1xff69v-14"
})(["font-size:", ";line-height:", ";", " font-family:", ";"], function (props) {
  return props.theme.fontSizeBodyLarge;
}, function (props) {
  return props.theme.lineHeightPortfolioBodyLarge;
}, _MediaQueries["default"].minWidth.portfolioDesktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: ", ";\n  "])), function (props) {
  return props.theme.fontSizeHeadingMedium;
}), function (props) {
  return props.theme.portfolioFontFamily || props.theme.fontFamilyDefault;
});
exports.GalleryTitle = GalleryTitle;